import React, { memo, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MenuItem from './menuItem'
import { setPageName } from '../../redux'
import Logo from './Logo'
import ChildMenu from './ChildMenu'
import {
  desktop_navbar_class,
  mobile_navbar_class,
  PAGES,
  MOBILE_PAGES,
  asideProducts,
  asideCars,
  asideIcons,
  asideTitles,
} from '../../functions/stateList'
import Logout from '../buttons/Logout'

function Aside() {
  const [active_name, setName] = useState('dashboard')
  const dispatch = useDispatch()
  let user_device = useSelector((state) => state?.deviceReducer?.device)
  let page_name = useSelector((state) => state?.pageNameReducer?.page_name)
  let child_page_name = useSelector((state) => state?.childPageNameReducer?.child_page_name)

  useEffect(() => {
    page_name && setName(page_name)
  }, [page_name])

  const pageHandler = (name) => {
    if (name !== 'products' || name !== 'cars') {
      setName(name)
      dispatch(setPageName(name))
    }
  }

  return (
    <div
      className={`
        ${user_device === 'desktop' ? desktop_navbar_class : mobile_navbar_class}`}
    >
      {user_device === 'desktop' && <Logo user_device={user_device} />}

      {user_device === 'desktop' ? (
        <ul className={'pr-7'}>
          {PAGES.map((name) => (
            <li className={'mb-6'} key={name} onClick={() => pageHandler(name)}>
              {(name === 'products' && active_name === 'products') ||
              (name === 'cars' && active_name === 'cars') ? (
                <ChildMenu
                  asideProducts={asideProducts}
                  asideCars={asideCars}
                  name={name}
                  active_name={child_page_name}
                />
              ) : (
                <MenuItem
                  asideIcons={asideIcons}
                  asideTitles={asideTitles}
                  name={name}
                  active_name={active_name}
                />
              )}
            </li>
          ))}
          <li>
            <Logout user_device={user_device} />
          </li>
        </ul>
      ) : (
        <ul className={'flex flex-row items-center justify-around h-14'}>
          {MOBILE_PAGES.map((name) => (
            <li className={'inline-block'} key={name} onClick={() => pageHandler(name)}>
              <MenuItem
                asideIcons={asideIcons}
                asideTitles={asideTitles}
                name={name}
                active_name={active_name}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default memo(Aside)
